import { filter, map, orderBy } from "lodash-es";

import { getAgentTimestamp } from "@/pages/agent/utils/agent-date.utils";
import { buildAgentSearchableText } from "@/pages/agent/utils/agent-search.utils";
import {
  RoutineSortKey,
  type RoutineSortKey as RoutineSortKeyType,
} from "@/pages/agent/routines/use-agent-routines-search-params";
import type { AssistantRoutineObservable } from "@/store/assistant/AssistantRoutineObservable";

export type RoutineRowViewModel = {
  routine: AssistantRoutineObservable;
  searchableText: string;
};

export const buildRoutineRows = ({
  routines,
}: {
  routines: AssistantRoutineObservable[];
}): RoutineRowViewModel[] =>
  map(
    filter(routines, routine => !routine.fixed),
    routine => ({
      routine,
      searchableText: buildAgentSearchableText({
        values: [routine.label, routine.description],
      }),
    })
  );

export const getSortedRoutineRows = ({
  routineRows,
  sortKey,
}: {
  routineRows: RoutineRowViewModel[];
  sortKey: RoutineSortKeyType;
}) => {
  if (sortKey === RoutineSortKey.RecentlyUpdated) {
    return orderBy(
      routineRows,
      [
        routineRow =>
          getAgentTimestamp({
            value: routineRow.routine.updatedAt,
            fallback: 0,
          }),
        routineRow => routineRow.routine.label.toLowerCase(),
        routineRow => routineRow.routine.id,
      ],
      ["desc", "asc", "asc"]
    );
  }

  if (sortKey === RoutineSortKey.Name) {
    return orderBy(
      routineRows,
      [routineRow => routineRow.routine.label.toLowerCase(), routineRow => routineRow.routine.id],
      ["asc", "asc"]
    );
  }

  return orderBy(
    routineRows,
    [
      routineRow =>
        getAgentTimestamp({
          value: routineRow.routine.nextRunAt,
          fallback: Number.POSITIVE_INFINITY,
        }),
      routineRow => routineRow.routine.label.toLowerCase(),
      routineRow => routineRow.routine.id,
    ],
    ["asc", "asc", "asc"]
  );
};
